import { axiosCms } from 'Axios.js';
import { authToken } from 'store/utility';
import * as actionTypes from 'store/actions/actionTypes';
import { getKey } from 'store/utility';

const fetchProductsStart = () => ({ type: actionTypes.FETCH_PRODUCTS_START });
const fetchProductsEnd = products => ({ type: actionTypes.FETCH_PRODUCTS_END, products });
const fetchAllProductsEnd = allProducts => ({ type: actionTypes.FETCH_ALL_PRODUCTS_END, allProducts });

const getFilterTypologyEnd = filterTypology => ({ type: actionTypes.GET_FILTER_TYPOLOGY_END, filterTypology });

const updateProductStart = () => ({ type: actionTypes.UPDATE_PRODUCT_START });
const updateProductEnd = () => ({ type: actionTypes.UPDATE_PRODUCT_START });

const legendMap = {
  tiles: '1',
  stone: '2',
  mosaic: '3',
  wood: '4',
  vinyl: '5',
  countertop: '6',
};

const invertedLegendMap = (() => {
  const inverted = {};
  for (let key in legendMap) {
    inverted[legendMap[key]] = key;
  }
  return inverted;
})();

const promiseTypes = (types = [], f = '') => {
  const URI = '/products';
  return types.map(type => {
    return new Promise((resolve, reject) => {
      // axiosCms.defaults.headers.common['Authorization'] = token;
      axiosCms
        .get(URI, {
          params: {
            product_type_id: type,
            f: f,
          },
        })
        .then(response => {
          const { data } = response;
          resolve({ [type]: data });
        })
        .catch(err => {
          console.error(`fetchProducts err: `, err);
          reject(err);
        });
    });
  });
};

const promiseType = (type = 'all', f = '') => {
  const URI = '/products';

  if (type !== 'all') {
    return axiosCms.get(URI, {
      params: {
        product_type_id: legendMap[type],
        f: f,
      },
    });
  } else if (type === 'all') {
    const promises = Object.values(legendMap).map(e =>
      axiosCms.get(URI, {
        params: {
          product_type_id: e,
          f: f,
        },
      }),
    );
    return Promise.all(promises);
  } else {
    console.err('Unknown promise type');
  }
};

// TODO: refactor this cyclic data manipulation
// in products(action) and products(reducer)
export const fetchAllProducts = () => {
  return dispatch => {
    dispatch(fetchProductsStart());

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
    const axiosPromise = promiseType();
    return axiosPromise
      .then(responses => {
        const allProducts = responses.reduce((previous, response, index) => {
          const key = getKey(legendMap, (index + 1).toString());
          const { data } = response;
          previous[key] = data['products'];
          return previous;
        }, {});
        return dispatch(fetchAllProductsEnd(allProducts));
      })
      .catch(err => {
        console.error('#fetchAllProducts', err);
        return Promise.reject(err);
      });
  };
};

export const fetchProductsByFilters = (types, typologies) => {
  return dispatch => {
    dispatch(fetchProductsStart());

    let typologyIds = [];
    if (typologies) {
      Object.keys(typologies).map(key => {
        typologyIds = [...typologyIds, ...typologies[key]];
        return key;
      });
    }

    const data = {
      product_type_ids: types,
      typology_ids: typologyIds,
    };

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
    axiosCms.post('/products-typology/filter', data).then(response => {
      const { data } = response;
      return dispatch(fetchAllProductsEnd(data));
    });
  };
};

export const fetchProductsByTypes = (types = [], f) => {
  return dispatch => {
    dispatch(fetchProductsStart());

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
    let axiosPromises = promiseTypes(types, f);
    if (types.length === 0) {
      dispatch(fetchAllProducts());
    } else {
      return Promise.all(axiosPromises)
        .then(responses => {
          const products = responses.reduce((previous, response) => {
            const keyNum = Object.keys(response)[0];
            const data = response[keyNum];
            const key = invertedLegendMap[keyNum];
            previous[key] = data['products'];
            return previous;
          }, {});

          Object.keys(legendMap).map(key => {
            if (!products[key]) {
              products[key] = [];
            }

            return null;
          });

          return dispatch(fetchAllProductsEnd(products));
        })
        .catch(err => {
          console.error('#fetchProductsByTypes', err);
          return Promise.reject(err);
        });
    }
  };
};

export const fetchProducts = (type, f) => {
  if (!type) throw new Error('undefined type');
  return dispatch => {
    dispatch(fetchProductsStart());

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
    const axiosPromise = promiseType(type, f);
    return axiosPromise
      .then(response => {
        let { data } = response;
        let products = {};
        products[type] = data;
        return dispatch(fetchProductsEnd(products));
      })
      .catch(err => {
        console.error(`#fetchProducts`, err);
        return Promise.reject(err);
      });
  };
};

export const updateProduct = (id, type, values) => {
  return dispatch => {
    const {
      price: { price, gst },
      price_sale: { price_sale },
      unit,
      remark,
    } = values;
    const params = {
      price_cents: Math.round(price * 100),
      price_unit: unit,
      // gst: gst,
      price_sale: Math.round(price_sale * 100),
      remark,
    };
    dispatch(updateProductStart());

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
    return axiosCms
      .patch('/products/' + id, params)
      .then(resp => {
        dispatch(updateProductEnd());
        dispatch(fetchProducts(type));
        return 'completed';
      })
      .catch(err => {
        console.error(err);
        return Promise.reject(`#updateProduct: `, err);
      });
  };
};

export const getFilterTypology = (productTypeIds = []) => {
  return dispatch => {
    // cms.POST("/products-typology/filter", h.getTypologyFilterByProductTypes)
    const URI = '/products-typology/filter';

    const body = {
      product_types: productTypeIds,
    };

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

    return axiosCms
      .post(URI, body)
      .then(response => {
        const { data } = response;
        return dispatch(getFilterTypologyEnd(data));
      })
      .catch(err => {
        console.error(`#getFilterTypology`, err);
        return Promise.reject(err);
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/products.js